import _ from 'lodash';
import { Model } from 'backbone';

export default class FormGuide extends Model {
	url(){
		return `nrl/formguide/${this.get('id')}.json`;
	}

	setHeadToHeadPercentage(){
		const
			head_to_head = this.get('head_to_head'),
			total_wins = _.values(head_to_head)
				.reduce((sum, squad) => sum + squad.wins, 0);

		_.each(head_to_head, squad => {
			squad.wins_pct = Math.round(squad.wins / total_wins * 100)
		});

		this.set({ head_to_head });

		return this;
	}
}